<template>
  <div class="knowledge">
    <span
      class="knowledge-answer"
      v-for="(item, index) in options" :key="index">
      {{item.key}}.
      <span class="content" v-katexHtml="item.content"></span>
      <img :src="url" :key="url" v-for="url in getImgList(item)" alt="">
    </span>
    <!-- 正确答案 -->
    <div class="knowledge-true">
      <strong>正确答案 ：</strong>
      <span
        v-if="questionType !== 3"
        class="knowledge-answer knowledge-true__answer"
        >{{answer}}</span>
      <span
        v-else
        class="knowledge-answer knowledge-true__answer"
        v-for="(item, index) in answer"
        :key="index"
        v-katexHtml="item.content"
        ></span>
    </div>
    <!-- 单选错误答案 -->
    <!-- <ul v-if="questionType !== 3">
      <li v-for="(item, index) in detailsList" :key="index">
        <span class=knowledge-wrong>
          <span v-if="item.answer"> 错误答案 {{item.content}}</span>
          <span v-else>跳过此题</span>
          : {{item.num}} 人</span>
        <span
          v-for="(kitem, index) in item.account_ids"
          :key="index"
          class="knowledge-error">
          {{kitem.student_name}}
          <span v-if="item.account_ids.length > 1 &&  item.account_ids.length -1 !== index">、</span>
        </span>
      </li>
    </ul> -->
    <!-- 填空题错误答案渲染 -->
    <!-- <el-table
      v-else
      :data="detailsList"
      style="width: 90%">
      <el-table-column
        type="index"
        width="140"
        align="center"
        label="错误答案排名">
      </el-table-column>
      <el-table-column
        prop="answer"
        label="答案信息"
        width="500">
        <template slot-scope="scope">
         <div v-if="scope.row.answer.length < 1">
           跳过此题
         </div>
         <div
          v-else
          v-for="(item, index) in scope.row.answer"
          :key="index"
          v-katexHtml='item.content'>
         </div>
       </template>
      </el-table-column>
      <el-table-column
        prop="num"
        align="center"
        label="回答次数">
      </el-table-column>
      <el-table-column
        prop="error_than"
        align="center"
        label="占比数据">
        <template slot-scope="scope">
         <div>
           {{ scope.row.error_than }}%
         </div>
       </template>
      </el-table-column>
    </el-table> -->
    <!-- 文字解析 -->
    <div  class="knowledge-analysis">
      <strong>文字解析:</strong>
      <div class="knowledge-analysis__text">
        <p v-for=" item in analyze" :key="item.id" v-katexHtml="item.content[0].content"></p>
      </div>
    </div>
    <!-- 视屏解析 -->
    <div class="knowledge-video" v-if="videoDate">
      <strong>视频解析:</strong>
      <div class="knowledge-video__button" round @click="openVideo">{{duration}}</div>
    </div>
    <!-- 所属知识点 -->
    <div class="knowledge-be" v-if="knowledgeName.length > 0">
      <strong>所属知识点:</strong>
      <div class="knowledge-be__text" v-for="item in knowledgeName" :key="item.id">
        {{item.tag_name}}
      </div>
    </div>

    <DetailedDialog :isShow.sync="isShow" :type="type" :videoUrl="videoDate" />
  </div>
</template>

<script>
import DetailedDialog from '@/views/pt/class-analysis/components/detailed-dialog.vue';
// import { htmlEncodeByRegExp } from '@/utils/index';
import { questionDetails } from '@/api/pt';

export default {
  name: 'Knowledge',
  components: {
    DetailedDialog,
  },
  props: {
    topicInfo: {
    },
  },
  data() {
    return {
      isShow: false,
      type: false,
      // knowledgeName: [], // 所属知识点
      duration: '',
      evaluateId: '',
      classId: '',
      detailsList: [],
    };
  },
  watch: {
  },
  computed: {
    options() {
      return this.topicInfo.row.options;
    },
    questionType() {
      return this.topicInfo.row.question_type;
    },
    analyze() {
      return this.topicInfo.row.analyze;
    },
    answer() {
      if (this.topicInfo.row.question_type === 3) {
        return this.topicInfo.row.answer && this.topicInfo.row.answer.flat();
      }
      return this.topicInfo.row.answer;
    },
    knowledgeName() {
      return this.topicInfo.row.factors;
    },
    videoDate() {
      return this.topicInfo.row.question_source && this.topicInfo.row.question_source[0]
      && this.topicInfo.row.question_source[0].source_url;
    },
  },
  mounted() {
    this.videoTime();
    // this.questionDetails();
  },
  methods: {
    questionDetails() {
      questionDetails({
        class_id: this.$attrs.classId,
        question_id: this.topicInfo.row.question_uuid,
        start_time: this.$attrs.startDate,
        end_time: this.$attrs.endDate,
      }).then((res) => {
        this.detailsList = res.data.questionAnswer;
      });
    },
    getImgList(data) {
      if (!data.img_data) {
        return [];
      }
      return data.img_data.map((item) => item.source);
    },
    openVideo() {
      this.isShow = true;
    },
    videoTime() {
      const audio = new Audio(this.videoDate);
      // 元数据已加载
      audio.addEventListener('loadedmetadata', () => {
        // this.duration = audio.duration;
        if (audio.duration < 60) {
          this.duration = `00:${audio.duration}`;
          return;
        }
        let m = Math.floor(audio.duration / 60);
        let s = Math.floor(audio.duration % 60);
        s = s < 10 ? `0${s}` : s;
        m = m < 10 ? `0${m}` : m;
        this.duration = `${m} : ${s}`;
        console.log(this.duration);
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .knowledge {
    box-sizing: border-box;
    position: relative;
    min-height: 300px;
    background: #F5F7FA;
    border-radius: 8px;
    padding: 27px 0px 28px 45px;
    font-family: 'PingFangSC-Medium', 'PingFang SC';
    &-answer {
      padding-right: 20px;
      font-size: 14px;
      font-weight: 500;
      color: #606266;
      .content {
          display: inline-block;
      }
       p {
        display: inline-block;
      }
    }
    img {
      max-width: 100px;
    }
    &-true {
      margin-top: 32px;
      margin-bottom: 10px;
      font-size: 16px;
      color: #000000;
      &__answer {
        color: #67C23A;
      }
    }
    &-wrong {
      font-size: 14px;
      font-weight: 600;
      color: #F56C6C;
      margin-right: 17px;
    }
    &-error {
      font-size: 14px;
      color: #606266;
    }
    &-analysis {
      margin-top: 20px;
      font-size: 16px;
      color: #000000;
      position: relative;
      &__text {
        position: relative;
        // margin-left: 10px;
        left: 88px;
        top: -18px;
        p {
          display: block !important;
          max-width: 950px;
          font-size: 14px;
          font-weight: 600;
          color: #606266;
          // vertical-align: top;
        }
      }

    }
    &-video {
      font-size: 16px;
      margin-top: 16px;
      color: #000000;
      &__button {
        text-indent: 33px;
        display: inline-block;
        line-height: 28px;
        width: 84px;
        height: 28px;
        font-size: 12px;
        margin-left: 32px;
        color: #fff;
        border: 1px solid #ccc;
        border-radius: 14px;
        background: url('~@/views/pt/images/class_video.png')
        no-repeat #FFA82D 2px 2px;
      }
    }
    &-be {
      margin-top: 32px;
      color: #5E6166  ;
      &__text {
        display: inline-block;
        font-size: 14px;
        padding: 9px 13px;
        border-radius: 4px;
        line-height: 12px;
        border: 1px solid #DCDFE6;
        margin-left: 16px;
      }
    }
  }
</style>
